module.exports = __webpack_public_path__ + "/build/web/images/testimonials-right-1@3x.84f44c68689c11408fb0cae5296dee87.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/testimonials-right-1@3x.jpg
// module id = 202
// module chunks = 13